import moment from 'moment';
import isDateValid from './isDateValid';

const getJourneyDateRange = (startDate, endDate, format = 'DD MMM Y') => {
  if (!isDateValid(startDate) || !isDateValid(endDate)) return null;

  const formattedStartDate = moment(startDate).format(format);
  const formattedEndDate = moment(endDate).format(format);

  if (formattedStartDate === formattedEndDate) return formattedStartDate;

  return `${formattedStartDate} - ${formattedEndDate}`;
};

export default getJourneyDateRange;
